import Vue, { CreateElement } from 'src/vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { Button } from '@src/elements/button/button'
import { Filter } from '@src/routes/content/components/filter'
import { ExerciseFilters, ExerciseTagFilter } from '@src/state/store'
import { availableEquipment, NO_EQUIPMENT } from '@src/util/constants'
import { Input } from '@src/elements/input/input'
import { Modal } from '@src/elements/modal/modal'

import './exercise-tags-filters.sass'
import { ExerciseResponse } from '@src/data/exercise-response'
import { defaultExerciseFilters } from '@src/state/dafaults'
import { Tooltip } from '@src/elements/tooltip/tooltip'
import { Icon } from '@src/elements/icon/icon'
import SessionManager from '@src/lib/session_manager'
import {
  getCountersForEquipmentFilter,
  getCountersForExerciseTagFilter
} from '@src/util/exercise-facet-counts'

@Component({
  computed: {
    exerciseTags: {
      get: function () {
        return this.$store.state.exerciseTags
      }
    },
    equipment: {
      get: function () {
        let list: string[] = []
        this.$store.state.availableExercises.forEach(exercise => {
          list = Array.from(new Set(list.concat(exercise.equipment))) // remove duplicates from equipment list
        })
        return list
      }
    },
    exerciseFilters: {
      get: function () {
        return this.$store.state.exerciseFilters || []
      },
      set: function (filters) {
        this.$store.state.exerciseFilters = filters
      }
    },
    availableExercises: {
      get: function () {
        return this.$store.state.availableExercises
      }
    }
  }
})
export default class ExerciseTagsFilters extends Vue {

  @Prop({ required: false, default: false })
  expandable: boolean

  private exerciseTags: any

  private exerciseFilters: ExerciseFilters
  private newExerciseFiltersTags: ExerciseTagFilter = {
    movement: new Set([]),
    focus: new Set([]),
    equipment: new Set([]),
    muscle: new Set([]),
    body: new Set([]),
    phase: new Set([]),
    category: new Set([]),
    clinical: new Set([]),
    execution: new Set([]),
    exercise: new Set([]),
    joints: new Set([]),
    range: new Set([])
  }
  private availableExercises: ExerciseResponse[]
  private filterCounters: Map<string, Array<any>> = new Map()

  private equipment: string[]
  private equipmentFilterList: string[]
  private showFilters: boolean = false
  private filterFavourites: boolean = false

  constructor () {
    super()
  }

  created () {
    this.equipmentFilterList = this.equipment ? [...this.equipment] : /* istanbul ignore next: the equipment computed always returns a list */ [...availableEquipment]
    this.equipmentFilterList.unshift(NO_EQUIPMENT)
  }

  beforeMount () {
    if (this.exerciseFilters.tags) {
      this.newExerciseFiltersTags = this.initializeExerciseFilters(this.exerciseFilters.tags)
    }
    // Sync favorites filter with store
    this.filterFavourites = this.exerciseFilters.favoritesOnly || false
  }

  @Watch('exerciseFilters.favoritesOnly')
  onFavoritesFilterChange (newVal: boolean) {
    this.filterFavourites = newVal || false
  }

  @Watch('exerciseTags')
  onExerciseTagsChange () {
    this.filterCounters = new Map()
    this.initializeFilterCounters()
  }

  @Watch('availableExercises')
  onAvailableExercisesChange () {
    this.filterCounters = new Map()
    this.initializeFilterCounters()
    this.equipmentFilterList = this.equipment ? [...this.equipment] : /* istanbul ignore next: the equipment computed always returns a list */ [...availableEquipment]
    if (!this.equipmentFilterList.includes(NO_EQUIPMENT)) {
      this.equipmentFilterList.unshift(NO_EQUIPMENT)
    }
  }

  initializeExerciseFilters (tags?) {
    return {
      movement: new Set(tags['movement'] || []),
      focus: new Set(tags['focus'] || []),
      equipment: new Set(tags['equipment'] || []),
      muscle: new Set(tags['muscle'] || []),
      body: new Set(tags['body'] || []),
      phase: new Set(tags['phase'] || []),
      category: new Set(tags['category'] || []),
      clinical: new Set(tags['clinical'] || []),
      execution: new Set(tags['execution'] || []),
      exercise: new Set(tags['exercise'] || []),
      joints: new Set(tags['joints'] || []),
      range: new Set(tags['range'] || [])
    } as ExerciseTagFilter
  }

  initializeFilterCounters () {
    if (this.filterCounters.size > 0 || this.exerciseTags.length === 0) {
      return
    }
    this.filterCounters.set('ExerciseTags::Execution', this.getCountersForFilter('ExerciseTags::Execution'))
    this.filterCounters.set('ExerciseTags::Category', this.getCountersForFilter('ExerciseTags::Category'))
    this.filterCounters.set('ExerciseTags::BodyArea', this.getCountersForFilter('ExerciseTags::BodyArea'))
    this.filterCounters.set('ExerciseTags::MuscleGroup', this.getCountersForFilter('ExerciseTags::MuscleGroup'))
    this.filterCounters.set('ExerciseTags::Joints', this.getCountersForFilter('ExerciseTags::Joints'))
    this.filterCounters.set('equipment', this.getCountersForEquipment())
    this.filterCounters.set('ExerciseTags::MovementPattern', this.getCountersForFilter('ExerciseTags::MovementPattern'))
    this.filterCounters.set('ExerciseTags::RangeOfMotion', this.getCountersForFilter('ExerciseTags::RangeOfMotion'))
    this.filterCounters.set('ExerciseTags::Exercise', this.getCountersForFilter('ExerciseTags::Exercise'))
    this.filterCounters.set('ExerciseTags::Focus', this.getCountersForFilter('ExerciseTags::Focus'))
    this.filterCounters.set('ExerciseTags::ClinicalPictures', this.getCountersForFilter('ExerciseTags::ClinicalPictures'))
    this.filterCounters.set('ExerciseTags::Level', this.getCountersForFilter('ExerciseTags::Level'))
  }

  addRemoveTagFilter (tags: Set<string>, tag: string) {
    if (tags.has(tag)) {
      tags.delete(tag)
    } else {
      tags.add(tag)
    }
    return tags
  }

  filterByTag (tag: string, type: string) {
    if (this.expandable === false) {
      this.newExerciseFiltersTags[type] = this.addRemoveTagFilter(this.newExerciseFiltersTags[type], tag)
      this.$store.dispatch('filterExercises', { tags: this.newExerciseFiltersTags })
    } else {
      this.newExerciseFiltersTags[type] = new Set<string>(this.addRemoveTagFilter(this.newExerciseFiltersTags[type], tag))
    }
  }

  clearTags (type: string) {
    if (this.expandable === false) {
      this.newExerciseFiltersTags[type] = new Set([])
      this.$store.dispatch('filterExercises', { tags: this.newExerciseFiltersTags })
    } else {
      this.newExerciseFiltersTags[type] = new Set([])
    }
  }

  filterByName (value: string) {
    this.$store.dispatch('filterExercises', { name: value })
  }

  clearFilters () {
    this.newExerciseFiltersTags = this.initializeExerciseFilters({})
    this.filterFavourites = false
    this.$store.dispatch('filterExercises', defaultExerciseFilters())
  }

  saveNewFiltersTags () {
    this.$store.dispatch('filterExercises', { tags: this.newExerciseFiltersTags })
    this.invertShowFilters()
  }

  invertShowFilters () {
    this.showFilters = !this.showFilters
    this.newExerciseFiltersTags = this.exerciseFilters.tags ? this.initializeExerciseFilters(this.exerciseFilters.tags) : this.initializeExerciseFilters()
  }

  filtersEmpty () {
    for (let type in this.exerciseFilters.tags!) {
      if (this.exerciseFilters.tags![type].size > 0) return false
    }
    return !this.filterFavourites
  }

  render (h: CreateElement) {
    if (!this.exerciseTags) {
      return
    }

    if (this.expandable === false) {
      return this.renderFiltersAllVisible(h)
    } else {
      return this.renderFiltersExpandable(h)
    }
  }

  getCountersForFilter (type): Array<any> {
    return getCountersForExerciseTagFilter(this.availableExercises, this.exerciseTags, type)
  }

  getCountersForEquipment (): Array<any> {
    return getCountersForEquipmentFilter(this.availableExercises, this.equipmentFilterList)
  }

  renderFiltersAllVisible (h: CreateElement) {
    this.initializeFilterCounters()
    return <div class='filters'>
      <Filter tag={'executionFilters'}
              filterList={this.exerciseTags['ExerciseTags::Execution']}
              counter={this.filterCounters.get('ExerciseTags::Execution')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.EXECUTION_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['execution'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'execution')}
              clearAllCallback={() => this.clearTags('execution')} />
      <Filter tag={'categoryFilters'}
              filterList={this.exerciseTags['ExerciseTags::Category']}
              counter={this.filterCounters.get('ExerciseTags::Category')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.CATEGORY_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['category'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'category')}
              clearAllCallback={() => this.clearTags('category')} />
      <Filter tag={'bodyFilters'}
              filterList={this.exerciseTags['ExerciseTags::BodyArea']}
              counter={this.filterCounters.get('ExerciseTags::BodyArea')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.BODY_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['body'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'body')}
              clearAllCallback={() => this.clearTags('body')} />
      <Filter tag={'muscleFilters'}
              filterList={this.exerciseTags['ExerciseTags::MuscleGroup']}
              counter={this.filterCounters.get('ExerciseTags::MuscleGroup')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.MUSCLE_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['muscle'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'muscle')}
              clearAllCallback={() => this.clearTags('muscle')} />
      <Filter tag={'jointsFilters'}
              filterList={this.exerciseTags['ExerciseTags::Joints']}
              counter={this.filterCounters.get('ExerciseTags::Joints')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.JOINTS_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['joints'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'joints')}
              clearAllCallback={() => this.clearTags('joints')} />
      <Filter tag={'equipmentFilters'}
              filterList={this.equipmentFilterList}
              counter={this.filterCounters.get('equipment')}
              placeholder={this.$t('EQUIPMENT')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['equipment'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'equipment')}
              clearAllCallback={() => this.clearTags('equipment')} />
      <Filter tag={'movementFilters'}
              filterList={this.exerciseTags['ExerciseTags::MovementPattern']}
              counter={this.filterCounters.get('ExerciseTags::MovementPattern')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.MOVEMENT_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['movement'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'movement')}
              clearAllCallback={() => this.clearTags('movement')} />
      <Filter tag={'rangeFilters'}
              filterList={this.exerciseTags['ExerciseTags::RangeOfMotion']}
              counter={this.filterCounters.get('ExerciseTags::RangeOfMotion')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.RANGE_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['range'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'range')}
              clearAllCallback={() => this.clearTags('range')} />
      <Filter tag={'exerciseFilters'}
              filterList={this.exerciseTags['ExerciseTags::Exercise']}
              counter={this.filterCounters.get('ExerciseTags::Exercise')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.EXERCISE_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['exercise'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'exercise')}
              clearAllCallback={() => this.clearTags('exercise')} />
      <Filter tag={'focusFilters'}
              filterList={this.exerciseTags['ExerciseTags::Focus']}
              counter={this.filterCounters.get('ExerciseTags::Focus')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.FOCUS_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['focus'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'focus')}
              clearAllCallback={() => this.clearTags('focus')} />
      <Filter tag={'clinicalFilters'}
              filterList={this.exerciseTags['ExerciseTags::ClinicalPictures']}
              counter={this.filterCounters.get('ExerciseTags::ClinicalPictures')}
              placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.CLINICAL_PLACEHOLDER')}
              translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
              selectedFilters={this.exerciseFilters.tags!['clinical'] || new Set([])}
              filterCallback={(value) => this.filterByTag(value, 'clinical')}
              clearAllCallback={() => this.clearTags('clinical')} />
      <Input ref='searchByName' class='search filter wide' search={true} valueChanged={this.filterByName}
             placeholder={this.$t('SEARCH_PLACEHOLDER')} value={this.exerciseFilters.name} />
      <Button type='remove' ref='clearFiltersBtn' label={this.$t('PAGE.CONTENT.WORKOUTS.CLEAR_FILTERS')} click={this.clearFilters} />
      <div class='spacer' />
    </div>
  }

  renderSwitchButton (h: CreateElement) {
    return (

        <div class={`type-switchers`}>
          <div class={`type-switchers`}>
            <div class={`type-switcher`}>
              <Tooltip content={this.$t('PAGE.CONTENT.EXERCISES.FAVORITES_ONLY')}
                       class={`option ${this.filterFavourites ? 'selected' : ''}`}>
                <Icon name={`${this.filterFavourites ? 'util/starRed-filled' : 'util/starRed'}`} click={() => {
                  this.filterFavourites = !this.filterFavourites
                  this.$store.dispatch('filterExercises', { favoritesOnly: this.filterFavourites })
                }}/>
              </Tooltip>
            </div>
          </div>
        </div>
    )
  }
  renderFiltersExpandable (h: CreateElement) {
    this.initializeFilterCounters()
    return <div class='filters'>
      <div class='outside-modal-filters'>
        <Input ref='searchByName' class='search filter' search={true} valueChanged={this.filterByName}
               placeholder={this.$t('SEARCH_PLACEHOLDER')} value={this.exerciseFilters.name} />
        <Button type={` ${(this.exerciseFilters.tags && !this.filtersEmpty()) ? 'square-outline-blue' : 'square-outline-red'}`}
                label={this.$t('PAGE.CONTENT.WORKOUTS.SHOW_FILTERS').toString().toUpperCase()} class='expand' click={this.invertShowFilters} />
        {!this.filtersEmpty() ?
          <Button type='remove' ref='clearFiltersBtn' label={this.$t('PAGE.CONTENT.WORKOUTS.CLEAR_FILTERS')} click={this.clearFilters} /> : null}

        {SessionManager.Instance.notMemberOrAssistant() && this.renderSwitchButton(h)}
      </div>
      <Modal class={'workout-filters-modal'} show={this.showFilters} closeCallback={this.invertShowFilters} overflow='visible'>
        <div slot='header'>
          {this.$t('PAGE.CONTENT.WORKOUTS.SHOW_FILTERS').toString()}
        </div>
        <div class='modal-body-filters'>
          <Filter tag={'executionFilters'}
                  filterList={this.exerciseTags['ExerciseTags::Execution']}
                  counter={this.filterCounters.get('ExerciseTags::Execution')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.EXECUTION_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['execution']}
                  filterCallback={(value) => this.filterByTag(value, 'execution')}
                  clearAllCallback={() => this.clearTags('execution')} />
          <Filter tag={'categoryFilters'}
                  filterList={this.exerciseTags['ExerciseTags::Category']}
                  counter={this.filterCounters.get('ExerciseTags::Category')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.CATEGORY_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['category']}
                  filterCallback={(value) => this.filterByTag(value, 'category')}
                  clearAllCallback={() => this.clearTags('category')} />
          <Filter tag={'bodyFilters'}
                  filterList={this.exerciseTags['ExerciseTags::BodyArea']}
                  counter={this.filterCounters.get('ExerciseTags::BodyArea')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.BODY_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['body']}
                  filterCallback={(value) => this.filterByTag(value, 'body')}
                  clearAllCallback={() => this.clearTags('body')} />
          <Filter tag={'muscleFilters'}
                  filterList={this.exerciseTags['ExerciseTags::MuscleGroup']}
                  counter={this.filterCounters.get('ExerciseTags::MuscleGroup')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.MUSCLE_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['muscle']}
                  filterCallback={(value) => this.filterByTag(value, 'muscle')}
                  clearAllCallback={() => this.clearTags('muscle')} />
          <Filter tag={'jointsFilters'}
                  filterList={this.exerciseTags['ExerciseTags::Joints']}
                  counter={this.filterCounters.get('ExerciseTags::Joints')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.JOINTS_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['joints']}
                  filterCallback={(value) => this.filterByTag(value, 'joints')}
                  clearAllCallback={() => this.clearTags('joints')} />
          <Filter tag={'equipmentFilters'}
                  filterList={this.equipmentFilterList}
                  counter={this.filterCounters.get('equipment')}
                  placeholder={this.$t('EQUIPMENT')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['equipment']}
                  filterCallback={(value) => this.filterByTag(value, 'equipment')}
                  clearAllCallback={() => this.clearTags('equipment')} />
          <Filter tag={'movementFilters'}
                  filterList={this.exerciseTags['ExerciseTags::MovementPattern']}
                  counter={this.filterCounters.get('ExerciseTags::MovementPattern')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.MOVEMENT_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['movement']}
                  filterCallback={(value) => this.filterByTag(value, 'movement')}
                  clearAllCallback={() => this.clearTags('movement')} />
          <Filter tag={'rangeFilters'}
                  filterList={this.exerciseTags['ExerciseTags::RangeOfMotion']}
                  counter={this.filterCounters.get('ExerciseTags::RangeOfMotion')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.RANGE_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['range']}
                  filterCallback={(value) => this.filterByTag(value, 'range')}
                  clearAllCallback={() => this.clearTags('range')} />
          <Filter tag={'exerciseFilters'}
                  filterList={this.exerciseTags['ExerciseTags::Exercise']}
                  counter={this.filterCounters.get('ExerciseTags::Exercise')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.EXERCISE_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['exercise']}
                  filterCallback={(value) => this.filterByTag(value, 'exercise')}
                  clearAllCallback={() => this.clearTags('exercise')} />
          <Filter tag={'focusFilters'}
                  filterList={this.exerciseTags['ExerciseTags::Focus']}
                  counter={this.filterCounters.get('ExerciseTags::Focus')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.FOCUS_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['focus']}
                  filterCallback={(value) => this.filterByTag(value, 'focus')}
                  clearAllCallback={() => this.clearTags('focus')} />
          <Filter tag={'clinicalFilters'}
                  filterList={this.exerciseTags['ExerciseTags::ClinicalPictures']}
                  counter={this.filterCounters.get('ExerciseTags::ClinicalPictures')}
                  placeholder={this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.CLINICAL_PLACEHOLDER')}
                  translation={'PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.'}
                  selectedFilters={this.newExerciseFiltersTags['clinical']}
                  filterCallback={(value) => this.filterByTag(value, 'clinical')}
                  clearAllCallback={() => this.clearTags('clinical')} />

          </div>
        <div slot='footer'>
          <div class='btn-row'>
            <Button type='outline' label={this.$t('CANCEL')} click={this.invertShowFilters} />
            <Button class='save-btn' label={this.$t('APPLY')} click={this.saveNewFiltersTags} />
          </div>
        </div>

      </Modal>
      <div class='spacer' />
    </div>
  }

}
